import LiveEffect from './LiveEffect.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';
import {IntegerParameter} from 'parameters/AbstractParameter.js';
import {ROLL_EFFECT} from './constants.js';
import {ALWAYS_ON, ALWAYS_OFF, SYNCED} from './constants';

class RollEffect extends LiveEffect {
    constructor(track) {
        super('Roll Effect', ROLL_EFFECT, track);

        this.rollFactorParameter = new AbstractParameter(
            'Roll Factor', this, (o, x) => x,
            { min: 0.125,
              max: 8,
              unit: 'x', // unit
              defaultValue: 1,
            });
        this.registerParameter(this.rollFactorParameter);

        this.modeParameter = new IntegerParameter(
            'Mode', this, (o, x) => x,
            {
                min: ALWAYS_OFF,
                max: ALWAYS_ON,
                unit: '', // unit
                defaultValue: SYNCED,
            });
        this.registerParameter(this.modeParameter);
    }

    get mode() {
        return this.modeParameter.get();
    }

    set mode(mode) {
        this.modeParameter.set(mode);
    }

    get rollFactor() {
        return this.rollFactorParameter.get();
    }

    set rollFactor(factor) {
        this.rollFactorParameter.set(factor);
    }

    getJson() {
        let json = super.getJson();
        json.rollFactor = this.rollFactor;
        json.mode = this.mode;

        json = this.saveParameterToJson(
            json, 'rollFactorParameter', this.rollFactorParameter);
        json = this.saveParameterToJson(
            json, 'modeParameter', this.modeParameter);

        return json;
    }

    fromJson(json) {
        super.fromJson(json);

        this.mode = json.mode;
        this.rollFactor = json.rollFactor;

        this.loadParameterFromJson(
            json, 'rollFactorParameter', this.rollFactorParameter);
        this.loadParameterFromJson(
            json, 'modeParameter', this.modeParameter);
    }

    getCopy(track) {
        let copied = new RollEffect(track);
        copied.fromJson(this.getJson());
        return copied;
    }
}

export default RollEffect;
